/**
 * Ідентифікатор горизонта виводиться з його ключа — [ADR-0023].
 *
 * Причина конкретна. Горизонт створюється **ліниво**, коли на день
 * уперше щось кладуть, і кожен пристрій робить це самостійно. З
 * випадковим ідентифікатором два пристрої, що писали в один день
 * офлайн, дають два рядки на той самий `(kind, key)` — а індекс
 * `UNIQUE(kind, key)` відхиляє другий. Пачка дельт падає, і падає на
 * кожному повторі з тим самим курсором: синхронізація мертва назавжди,
 * а не деградована.
 *
 * Детермінований вивід прибирає цей клас цілком: обидва пристрої
 * приходять до того самого ідентифікатора, не змовляючись.
 *
 * **Простір імен секретний, і це головне в цьому файлі.** З фіксованим
 * публічним простором будь-хто обчислив би ідентифікатор для будь-якого
 * дня — 36 500 значень покривають століття. Сервер бачить `entity_id`
 * відкрито, отже дізнався б точний перелік днів, у які людина щось
 * планувала, а з порядком дельт — ще й коли саме вона писала заднім
 * числом. Це поведінковий профіль із сервера, який обіцяє мінімум
 * метаданих. Простір, виведений із ключа даних, прибирає витік цілком:
 * сервер ключа не бачив ніколи.
 */
import { sha256 } from "@noble/hashes/sha2.js";
import { utf8ToBytes } from "@noble/hashes/utils.js";
import { purpose } from "../crypto/aead.js";
import { KEY_BYTES, asKey } from "../crypto/keys.js";
import { hkdf } from "@noble/hashes/hkdf.js";
import { uuidV8 } from "./uuid.js";
export function deriveHorizonNamespace(dek) {
    return asKey(hkdf(sha256, dek, undefined, purpose("horizon-id", "v1"), KEY_BYTES));
}
/**
 * `(kind, key)` → ідентифікатор. Та сама пара завжди дає той самий
 * рядок, на будь-якому пристрої цього акаунта.
 *
 * Двокрапка між частинами не косметична: без розділювача `("day", "1")`
 * і `("da", "y1")` дали б однакове джерело. Ключі горизонтів двокрапки
 * не містять, тож розбір однозначний.
 */
export function horizonIdFor(ns, kind, key) {
    const digest = sha256.create().update(ns).update(utf8ToBytes(`${kind}:${key}`)).digest();
    return uuidV8(digest);
}
//# sourceMappingURL=horizonId.js.map